"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.2 13.9",
    width: "27.2",
    height: "13.9"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M4.5,13.9c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5S7,10,7,11.4S5.9,13.9,4.5,13.9z M4.5,9.9 C3.7,9.9,3,10.6,3,11.4s0.7,1.5,1.5,1.5S6,12.2,6,11.4S5.3,9.9,4.5,9.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M26.7,11.9h-8.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h8.2c0.3,0,0.5,0.2,0.5,0.5S27,11.9,26.7,11.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M16.5,13.9c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5S19,10,19,11.4S17.9,13.9,16.5,13.9z M16.5,9.9 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S17.3,9.9,16.5,9.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M14.5,11.9h-8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h8c0.3,0,0.5,0.2,0.5,0.5S14.8,11.9,14.5,11.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M2.5,11.9h-2c-0.3,0-0.5-0.2-0.5-0.5V7.9c0-1.1,0.9-2,2-2h3.7l2.9-5.6C8.7,0.1,8.8,0,9,0l16.5,0h0 c0.3,0,0.5,0.2,0.5,0.5l0,10.9c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5l0-10.4L9.3,1L6.4,6.6C6.4,6.8,6.2,6.9,6,6.9H2 c-0.6,0-1,0.4-1,1v3h1.5c0.3,0,0.5,0.2,0.5,0.5S2.8,11.9,2.5,11.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M8.5,6.9c-0.1,0-0.2,0-0.2-0.1C8,6.7,7.9,6.4,8.1,6.2l1-2C9.1,4,9.3,3.9,9.5,3.9h1c0.3,0,0.5,0.2,0.5,0.5 s-0.2,0.5-0.5,0.5H9.8L8.9,6.6C8.9,6.8,8.7,6.9,8.5,6.9z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#9ECE06",
    cx: "21.8",
    cy: "5.5",
    r: "2.1"
  }));
};

exports["default"] = _default;